"use client";

import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import DashboardHeader from "@/components/headers/DashboardHeader";
import PricingV2 from "@/components/PricingV2";
import FooterLight from "@/components/FooterLight";
import LoadingSpinner from "@/components/LoadingSpinner";
import apiClient from "@/libs/api";

interface UserData {
  subscription: {
    priceId: string | null;
    status: string;
  };
}

export default function PricingPage() {
  const { data: session, status } = useSession();
  const pricingLayout = "v2_1";
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      if (status === "loading") {
        // Still loading auth state
        return;
      }

      if (status === "authenticated") {
        // Fetch user subscription data
        try {
          const data = await apiClient.get("/user/me");
          setUserData(data as unknown as UserData);
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Guest user - no subscription data to fetch
        setUserData(null);
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [status]);

  if (status === "loading" || isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <main className="flex-1 pb-24">
        {/* Header - matching dashboard pattern exactly */}
        <DashboardHeader />

        <PricingV2
          layout={pricingLayout}
          currentUserPriceId={
            userData?.subscription?.status === "active"
              ? userData?.subscription?.priceId || null
              : null
          }
        />
      </main>

      <FooterLight />
    </div>
  );
}
